import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="py-12 px-4 md:px-8 relative z-10 backdrop-blur-lg bg-background-dark/10">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div>
            <Link
              to="/"
              className="text-2xl font-bold bg-clip-text text-primary-600 mb-4 inline-block"
            >
              <img
                src="/images/karen-logo-yellow.svg"
                alt="logo"
                className="w-14"
              />
            </Link>
            <p className="text-gray-400 mt-4 max-w-xs">
              Building innovative software solutions that merge functionality,
              and efficiency.
            </p>
            <div className="flex space-x-4 mt-6">
              <SocialIcon
                href="https://www.linkedin.com/in/karenchb/"
                ariaLabel="LinkedIn"
                hoverClassName="hover:bg-social-linkedin"
              >
                <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
              </SocialIcon>
              <SocialIconAugmented
                href="https://x.com/bkakis1?s=21&t=cKnffPWbH75RQXdGkWpQPg"
                ariaLabel="Twitter"
                hoverClassName="hover:bg-social-twitter"
              >
                <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
              </SocialIconAugmented>
              <SocialIcon
                href="https://github.com/karenbanci"
                ariaLabel="GitHub"
                hoverClassName="hover:bg-social-github"
              >
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
              </SocialIcon>
              <SocialIcon
                href="https://www.instagram.com/kakabanci/"
                ariaLabel="Instagram"
                hoverClassName="hover:[background-image:theme(colors.social.instagram)] transition-colors"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </SocialIcon>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-primary-400">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-400  hover:text-white transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/projects"
                  className="text-gray-400  hover:text-white transition-colors"
                >
                  Projects
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-400  hover:text-white transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400  hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-primary-400">
              Services
            </h3>
            <ul className="space-y-2">
              <li>
                <span className="text-gray-400 ">Software Development</span>
              </li>
              <li>
                <span className="text-gray-400 ">Interactive Experiences</span>
              </li>
              <li>
                <span className="text-gray-400 ">React Development</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-primary-400">
              Contact
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="mailto:karenbanci1@gmail.com"
                  className="text-gray-400  hover:text-white transition-colors"
                >
                  karenbanci1@gmail.com
                </a>
              </li>
              <li>
                <span className="text-gray-400 ">Sunnyvale, CA</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm">
              © {year} Karen Banci. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <ul className="flex space-x-6">
                <li>
                  <a
                    href="#"
                    className="text-gray-500 hover:text-white text-sm transition-colors"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-gray-500 hover:text-white text-sm transition-colors"
                  >
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-gray-500 hover:text-white text-sm transition-colors"
                  >
                    Cookies Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

interface SocialIconProps {
  href: string;
  ariaLabel: string;
  children: React.ReactNode;
  hoverClassName: string;
  iconClassName?: string;
}

function SocialIcon({
  href,
  ariaLabel,
  children,
  hoverClassName,
  iconClassName = "",
}: SocialIconProps) {
  return (
    <a
      href={href}
      aria-label={ariaLabel}
      className={`w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center transition-all duration-300 ${hoverClassName}`}
    >
      <svg
        className={`w-5 h-5 ${iconClassName}`}
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        {children}
      </svg>
    </a>
  );
}

function SocialIconAugmented({ href, ariaLabel, children }: SocialIconProps) {
  return (
    <a
      href={href}
      aria-label={ariaLabel}
      className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center hover:bg-gradient-to-r from-primary-100 to-primary-400 transition-colors"
    >
      <svg
        className="w-5 h-5"
        fill="currentColor"
        viewBox="0 0 24 24"
        style={{ transform: "scale(1.4) translate(4px, 4px)" }}
      >
        {children}
      </svg>
    </a>
  );
}
